import { EmployeeDialogForm } from 'components/Employee/EmployeeDialogForm';
import { Checkbox } from 'components/Inputs/Checkbox';
import { useEmployees } from 'hooks/useEmployees';
import { useDisclose } from 'hooks/utilHooks';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { IEmployee, ThemeStatus } from 'types/Employee';
import { maskCpf, maskPhone } from 'util/masks';

import CreateIcon from '@mui/icons-material/Create';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Collapse,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';

const StyledTableRow = styled(TableRow)(() => ({
  '& > *': { borderBottom: 'unset !important' },
}));

export interface IEmployeeRow {
  employee: IEmployee;
}

type IStatus = {
  color: string;
  title: string;
};

const Status = ({ color, title }: IStatus) => {
  return <Typography color={color}>{title}</Typography>;
};

export const EmployeeRow: React.FC<IEmployeeRow> = ({ employee }) => {
  const form = useForm();
  const { selectEmployee, selectedEmployees } = useEmployees();

  const [open, setOpen] = useState(false);
  const { isOpen, onClose, onOpen } = useDisclose();

  const handleChecked = () => {
    selectEmployee(employee.id);
  };

  return (
    <>
      <StyledTableRow hover role="checkbox">
        <TableCell width={75} padding="checkbox">
          <FormProvider {...form}>
            <Checkbox
              name="isSelected"
              id="isSelected"
              checked={Boolean(selectedEmployees[employee.id])}
              onChange={handleChecked}
            />
          </FormProvider>
        </TableCell>
        <TableCell component="th" scope="row" sx={{ width: 260 }}>
          {employee.name}
        </TableCell>

        <TableCell sx={{ width: 240 }}>{employee.email}</TableCell>

        <TableCell>
          <Typography color="#4CAF50">Ativo</Typography>
        </TableCell>

        <TableCell>
          <Status
            color={
              ThemeStatus[
                `${employee?.company?.completedSignUp ? 'active' : 'inactive'}`
              ].color
            }
            title={
              ThemeStatus[
                `${employee?.company?.completedSignUp ? 'active' : 'inactive'}`
              ].title
            }
          />
        </TableCell>

        <TableCell>
          <Stack flexDirection="row" gap="8px">
            <Tooltip title="Editar">
              <IconButton aria-label="edit" color="inherit" onClick={onOpen}>
                <CreateIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title={open ? 'Ver menos' : 'Ver mais'}>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </Tooltip>
          </Stack>
        </TableCell>
      </StyledTableRow>

      <TableRow>
        <TableCell
          padding="checkbox"
          style={{
            paddingBottom: 0,
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
          }}
          colSpan={6}
        >
          <Collapse
            in={open}
            timeout="auto"
            unmountOnExit
            // sx={{ width: '51%' }}
          >
            <Table
              size="small"
              aria-label="more-info"
              sx={{ marginTop: 2, marginBottom: 4 }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ borderBottom: 'unset', width: 75 }} />
                  <TableCell
                    component="th"
                    scope="row"
                    width={260}
                    sx={{ borderBottom: 'unset' }}
                  >
                    <Typography variant="body2" color="#666E7A">
                      Número do CPF
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ borderBottom: 'unset', width: 240 }}>
                    <Typography variant="body2" color="#666E7A">
                      Telefone Celular
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ borderBottom: 'unset' }} />
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ borderBottom: 'unset' }}
                  />
                  <TableCell sx={{ borderBottom: 'unset' }}>
                    {maskCpf(employee.cpf)}
                  </TableCell>
                  <TableCell sx={{ borderBottom: 'unset' }}>
                    {Boolean(maskPhone(employee.phone))
                      ? maskPhone(employee.phone)
                      : '-'}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
      <EmployeeDialogForm
        title="Editar Colaborador"
        isOpen={isOpen}
        onClose={onClose}
        id={employee.id}
        employee={employee}
      />
    </>
  );
};
